import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function BonusNotFound() {
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Bonus game not found"
      description="It may have settled (and moved to the settled list), or the link is out of date."
      action={
        <Button variant="outline" asChild>
          <Link to="/bonus-games">Back to bonus games</Link>
        </Button>
      }
    />
  );
}
